import Typography from "@material-ui/core/Typography";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CampaignCreationSlideContainer from "../../../components/CampaignCreation/CampaignCreationSlideContainer";
import RoleTitleSelectionDashboard from "./components/RoleTitleSelectionDashboard";
import classes from "./RoleTitleSelectionSlide.module.scss";
import { CookieSet } from "../../../types/campaignTypes";
import { PageStepComponentProps } from "../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { errorToaster } from "../../../helpers/toasters";
import { getRoleTitleList, setCampaignCookies } from "../../../redux/reducers/campaignToCreate/actions";

const RoleTitleSelectionSlide: FC<PageStepComponentProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
}) => {
  const roleTitleList = useSelector((state: ReduxApplicationState) =>
    state.campaignToCreate.roleTitleList.filter((roleTitleGroup) => roleTitleGroup.roleType !== "Companies"),
  );
  const campaignCookieSets = useSelector((state: ReduxApplicationState) => state.campaignToCreate.campaignCookieSets);
  const isRoleTitleListPending = useSelector((state: ReduxApplicationState) => state.campaignToCreate.isPending);

  const dispatch = useDispatch();

  const [selectedCookieSets, setSelectedCookieSets] = useState<Record<string, CookieSet[]>>(() => {
    return campaignCookieSets || {};
  });

  useEffect(() => {
    if (roleTitleList.length === 0) {
      dispatch(getRoleTitleList());
    }
  }, [dispatch, roleTitleList.length]);

  useEffect(() => {
    if (isAttemptingToGoNext && handleNext && setIsAttemptingToGoNext) {
      const haveSelectedRoleTitles = !!Object.values(selectedCookieSets).find((val) => val.length);
      if (haveSelectedRoleTitles) {
        dispatch(setCampaignCookies(selectedCookieSets));
        handleNext();
        setIsAttemptingToGoNext(false);
      } else {
        errorToaster("Please, select at least one Role/Title to continue.", 5000);
        setIsAttemptingToGoNext(false);
      }
    }
  }, [dispatch, handleNext, isAttemptingToGoNext, selectedCookieSets, setIsAttemptingToGoNext]);

  const mainContent = () => (
    <>
      {isRoleTitleListPending ? (
        <Typography className={`${classes.loaderLabel} ${!setIsAttemptingToGoNext && classes.loaderLabelOnPage}`}>
          Please, wait while we get everything in order...
        </Typography>
      ) : null}

      {!isRoleTitleListPending && roleTitleList.length !== 0 ? (
        <RoleTitleSelectionDashboard
          roleTitleList={roleTitleList}
          selectedCookieSets={selectedCookieSets}
          setSelectedCookieSets={setSelectedCookieSets}
        />
      ) : null}
    </>
  );

  return (
    <div
      style={{
        padding: !setIsAttemptingToGoNext ? "4rem" : 0,
      }}
    >
      {setIsAttemptingToGoNext ? (
        <CampaignCreationSlideContainer heading="Role/ Title Selection">{mainContent()}</CampaignCreationSlideContainer>
      ) : (
        mainContent()
      )}
    </div>
  );
};

export default RoleTitleSelectionSlide;
